import {$http} from '@/utils/https'
import {
    EVENTS_CHANGE_SKIP,
    EVENTS_ITEM_REQUEST_STATUS,
    EVENTS_REQUEST_STATUS,
    EVENTS_SET_ITEM,
    EVENTS_SET_LIST,
    EVENTS_SET_LIST_LENGTH,
} from './types/mutation-types';

import {FETCH_EVENTS, FETCH_EVENTS_ITEM} from './types/action-types';


const state = {
    list: null,
    currentItem: null,
    isListLoading: false,
    isCurrentItemLoading: false,
    skip: 0,
    limit: 9,
    listLength: 0,
};

const getters = {
    list: state => state.list,
    currentItem: state => state.currentItem,
    listLength: state => state.listLength,
    skip: state => state.skip,
    isListLoading: state => state.isListLoading,
    isCurrentItemLoading: state => state.isCurrentItemLoading,
};

const actions = {
    [FETCH_EVENTS]: async ({commit}, payload) => {
        try {
            commit(EVENTS_REQUEST_STATUS, true);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/events?skip=${state.skip}&limit=${state.limit}&include=image,image.seo,speakers&use_as_id=slug`);
            commit(EVENTS_SET_LIST, response.data.data);
            commit(EVENTS_SET_LIST_LENGTH, response.data.meta.total);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(EVENTS_REQUEST_STATUS, false);
        }
    },
    [FETCH_EVENTS_ITEM]: async ({commit}, payload) => {
        try {
            commit(EVENTS_ITEM_REQUEST_STATUS, true);
            commit(EVENTS_SET_ITEM, null);

            const response = await $http.get(`${process.env.VUE_APP_ROOT_COURSE}courses/${payload.item}/events/${payload.eventSlug}?include=image,seo,image.seo,speakers&use_as_id=slug`);
            commit(EVENTS_SET_ITEM, null);
            commit(EVENTS_SET_ITEM, response.data.data);
            return response;
        } catch (e) {
            throw e;
        } finally {
            commit(EVENTS_ITEM_REQUEST_STATUS, false);
        }
    },
};

const mutations = {
    [EVENTS_SET_LIST](state, data) {
        if (!data) state.list = data;
        !state.list.length ? state.list = data : state.list.push(...data);
    },
    [EVENTS_SET_LIST_LENGTH](state, length) {
        state.listLength = length;
    },
    [EVENTS_CHANGE_SKIP](state, status) {
        if (status) state.skip = 0;
        else state.skip += state.limit;
    },
    [EVENTS_SET_ITEM](state, data) {
        state.currentItem = data;
    },
    [EVENTS_REQUEST_STATUS](state, status) {
        state.isListLoading = status;
    },
    [EVENTS_ITEM_REQUEST_STATUS](state, status) {
        state.isCurrentItemLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
